import React, { Component, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect, useSelector, useDispatch } from 'react-redux';
import * as UserActions from 'modules/user/user.actions';
import * as PostActions from 'modules/post/post.actions';
import { logoutAction, setCommunity } from 'modules/auth/auth.actions';
import { authProps } from 'app/utils/propValidation';
import Profile from 'modules/profile/profile.component';
import UserPosts from 'modules/profile/web/userPosts.component';
import { Divider, View } from 'modules/styled';
import { showModal, hideModal } from 'modules/navigation/navigation.actions';
import Linkify from 'linkifyjs/react';
import { useLocation } from 'react-router-dom';

const pageSize = 10;

class ProfileContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    match: PropTypes.object,
    usersState: PropTypes.object.isRequired,
    auth: authProps,
    screenSize: PropTypes.number,
  };

  state = {
    user: {},
    isOwner: false,
  };

  static getDerivedStateFromProps(props) {
    const { auth, match, usersState } = props;
    const handle = match.params.id;
    const userId = usersState.handleToId[handle];
    const user = usersState.users[userId];
    if (!user) return null;
    const isOwner = auth.user && user._id === auth.user._id;
    return { user, isOwner };
  }

  // Get user object based on userid param in route
  grabUser() {
    const { id } = this.props.match.params;
    this.props.actions.getSelectedUser(id);
  }

  // Get array of posts based on userid param in route
  grabPosts = (l) => {
    const { id } = this.props.match.params;
    this.props.actions.getUserPosts(l || 0, pageSize, id);
  };

  componentDidMount() {
    this.grabUser();
  }

  componentDidUpdate(nextProps) {
    const { id } = this.props.match.params;
    if (id !== nextProps.match.params.id) {
      this.grabUser();
    }
  }

  render() {
    const { user } = this.state;
    const bio = user.bio && <Linkify>{user.bio}</Linkify>;
    return (
      <View sx={{ mb: 20 }}>
        <Profile
          key={this.state.user._id + 'profile'}
          {...this.props}
          {...this.state}
          bio={bio}
        />
        <Divider sx={{ m: [0, 4] }} />
        <UserPosts
          key={this.state.user._id}
          {...this.props}
          {...this.state}
          load={this.grabPosts}
          pageSize={pageSize}
        />
        <SetCommunity />
      </View>
    );
  }
}

function SetCommunity() {
  const location = useLocation();
  const dipatch = useDispatch();
  const searchParams = new URLSearchParams(location.search);
  const c = searchParams.get('community');
  const community = useSelector((state) => state?.auth?.community);
  useEffect(() => {
    if (!community && c) dipatch(setCommunity(c));
  }, [community, c, dipatch]);
  return null;
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
  usersState: state.user,
  posts: state.posts,
  investments: state.investments,
  myPostInv: state.investments.myPostInv,
  community: state.community,
  screenSize: state.navigation.screenSize,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  actions: bindActionCreators(
    {
      ...UserActions,
      ...PostActions,
      hideModal,
      logoutAction,
      showModal,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileContainer);
